import React, { Component } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button } from '@mui/material';

import { Code } from '~/components/Common/Code';
import Spinner from '~/components/Common/Spinner';

import { retrievePNRBookingDetails } from '~/services/FlightsService';

function ToggleButton({ handleClick }) {
  return (
    <Button onClick={handleClick} endIcon={<ExpandMoreIcon />}>
      View JSON
    </Button>
  );
}

export default class Log extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleClick = this.handleClick.bind(this);

    this.state = {
      isOpen: false,
      isLoading: false,
      json: [],
    };
  }

  async handleClick() {
    const isOpen = !this.state.isOpen;

    this.setState({
      isOpen,
      isLoading: isOpen,
    });

    if (!isOpen) {
      return;
    }

    const json = await this.getPnrJson();

    this.setState({
      json,
      isLoading: false,
    });
  }

  async getPnrJson() {
    const { pnrId, region, provider } = this.props;

    try {
      const pnrDetails = await retrievePNRBookingDetails({
        pnrId,
        region,
        provider,
      });
      return pnrDetails;
    } catch (error) {
      return {
        type: 'Error in fetching PNR',
      };
    }
  }

  render() {
    const { isOpen, isLoading, json } = this.state;

    if (!isOpen) {
      return (
        <div>
          <ToggleButton isOpen={isOpen} handleClick={this.handleClick} />
        </div>
      );
    }

    if (isLoading) {
      return (
        <div>
          <ToggleButton isOpen={isOpen} handleClick={this.handleClick} />
          <Spinner />
        </div>
      );
    }

    return (
      <div>
        <ToggleButton isOpen={isOpen} handleClick={this.handleClick} />
        <Code lang="json" value={json} />
      </div>
    );
  }
}
